export default "__VITE_ASSET__CxKXV4RA__"